import Dialog from "../../atoms/dialog";
import { useState } from 'react'
import DeleteSimulationProfile from "../simulations/DeleteSimulationProfile";

const DeleteSimulationProfileAlert = (props) => {
    const { onCompletion, element, onClose, title, itemName, type, entityId, testsuiteId } = props;

    console.log(element, 'this is element');

    console.log('prpddd---->', props)
    const [open, setOpen] = useState(false)
    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (
        <Dialog
            title={title || "Delete Simulation profile"}
            open={true}
            handleClose={handleClose}
            paperProps={{ id: "deleteSimulationAlert" }}
        >
            <DeleteSimulationProfile type={type} testsuiteId={testsuiteId} entityId={entityId} onCompletion={onCompletion} content={`Are you sure to delete the profile ${itemName}?`} element={element} onClose={onClose} />

        </Dialog >
    )
}

export default DeleteSimulationProfileAlert;